
import {
    useSelector,
} from 'react-redux';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

/**
 * This function will return the boolean values based on the error.
 * @param cardname is the name of the Card
 */
export const checkCardHasError = (cardname: string) => {
    const stateerror = useSelector((state: any) => (state.errorstate));
    const errors:any = stateerror?.values;
    let result:boolean = false;
    if(errors?.length > 0){
        errors?.forEach((obj: ErrorObject) => {
            if (Array.isArray(obj?.erroritems)) {
                if(cardname && obj?.source && cardname === obj.source){
                    result = true;
                }
            }
        })
    }
    return result;
}

